import { I18n } from '@calendly/i18n'

import { Summary } from './summary'
import { AccordionPanel } from '../../../components/accordion'
import { Notifications } from '../../components/notifications'
import { useWorkflows } from '../use_workflows'

export const NotificationsPanel = ({ isLocked, ...props }) => {
  const workflows = useWorkflows({ withAdminManaged: true })

  return (
    <AccordionPanel
      titleId="notifications-label"
      title={I18n.t('publisher.event_type_editor.sections.more_options.notifications.title')}
      subheader={<Summary workflows={workflows.list || []} />}
      {...props}
    >
      <Notifications workflows={workflows} />
    </AccordionPanel>
  )
}
